import {
  MAX_AGENT_COMPONENT_DESCRIPTION_LENGTH,
  MAX_AGENT_COMPONENT_NAME_LENGTH,
  type AgentComponentType,
} from '@reach/shared-types/agent-components';
import { COMPONENT_PLACEHOLDERS, COMPONENT_TYPE_COPY } from '../agents-copy';
import type { ComponentDraft, ComponentDraftChange } from './component-draft';
import { COMPONENT_PAGE_COPY } from './component-page-copy';
import { FormCard } from './FormCard';
import { TextField } from './TextField';

interface DetailsCardProps {
  type: AgentComponentType;
  draft: ComponentDraft;
  onDraftChange: (change: ComponentDraftChange) => void;
}

/** The partner-facing name and description, which never reach the agent. */
export const DetailsCard = ({ type, draft, onDraftChange }: DetailsCardProps) => {
  const { nameLabel } = COMPONENT_TYPE_COPY[type];
  const placeholders = COMPONENT_PLACEHOLDERS[type];

  return (
    <FormCard title={COMPONENT_PAGE_COPY.detailsHeading}>
      <TextField
        label={nameLabel}
        help={COMPONENT_PAGE_COPY.nameHelp}
        placeholder={placeholders.name}
        value={draft.name}
        maxLength={MAX_AGENT_COMPONENT_NAME_LENGTH}
        required
        onChange={name => onDraftChange({ name })}
      />
      <TextField
        label={COMPONENT_PAGE_COPY.descriptionLabel}
        help={COMPONENT_PAGE_COPY.descriptionHelp}
        placeholder={placeholders.description}
        value={draft.description}
        maxLength={MAX_AGENT_COMPONENT_DESCRIPTION_LENGTH}
        onChange={description => onDraftChange({ description })}
      />
    </FormCard>
  );
};
